import { format, parseJSON } from 'date-fns';

function formatDateTime(inputDate, dateFormat) {
  let date;
  try {
    date = format(parseJSON(inputDate), dateFormat);
  } catch (err) {
    date = '';
  }
  return date;
}

export { formatDateTime }